import React, { useEffect, useState } from 'react';

import CardUi from '../components/common/Card';
import {Divider} from "antd";

const Insights: React.FC = () => {
  const [items, setItems] = useState([
    'Exceptional re-pricing movement',
    'Aligns selection price',
  ]);

  const items2 = [
    'High traffic destinations for sale promotion',
    'High traffic destinations - inventory by airlines',
    'Comparative price optimization by gaps',
  ];

  const items3 = [
    'Candidates for price raise',
    'Candidates for price reduction',
    'Last day alerts snapshot',
  ];

  useEffect(() => {
    console.log('insights page');
  }, []);

  return (
    <>
      <Divider style={{marginBottom:0}}>
        <h3 style={{ fontSize: '30px', fontWeight: 'bold', fontFamily: 'Arial, sans-serif', color: 'rgb(3 55 120)', letterSpacing: '0.5px' }}>Insights & Advanced reports</h3>
      </Divider>
      <div
      style={{
        margin: '60px auto',
        display: 'flex',
        gap: '3rem',
        flexDirection: 'column',
      }}
    >
            <div>
        <CardUi
          items={items}
          title="Choose one of reports to analyze competitors monitoring and outliers"
        />
      </div>
      <div>
        <CardUi
          items={items2}
          title="Choose one of flights with stops analyze reports"
        />
      </div>
      <div>
        <CardUi
          items={items3}
          title="Choose one of the alert & opportunities reports"
        />
      </div>
    </div>
      </>
  );
};

export default Insights;
